<template>
  <v-app style="height:100vh; overflow-y:auto">
    <div  class="device-register" :class="color"></div>
    <v-container fluid grid-list-xl>
      <v-layout row wrap>
        <v-flex d-flex xs12 sm12 md8>
          <v-card class="elevation-5">
            <v-img                        
                :src="require('@/assets/img/bg/frcground.jpg')"
                aspect-ratio="3.5"
            >
              <v-container fill-height fluid>
                <v-layout fill-height mr-4>
                  <v-flex xs12 align-center flexbox>
                    <span class="display-3 white--text" style="float:right">Flash RC</span>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-img>

            <v-card-text class="pa-0">          
              <v-tabs color="grey" dark v-model="selectedTab">
                <v-tab ripple href="#tab-1">
                  Syarat dan Ketentuan
                </v-tab>                
                <v-tabs-items v-model="selectedTab">
                  <v-tab-item value="tab-1">
                    <v-card flat style="height:60vh; overflow-y: auto">
                      <v-card-text>
                        <div style="text-align: justify;">
                            <b>Tata Cara Pendaftaran Account Saksi:</b>
                          </div>
                          <ul style="text-align: justify;">
                          <li>Saksi mengisi form disamping secara lengkap</li>
                          <li>Setelah berhasil terdaftar, saksi segera menghubungi PIC atau Koordinator Saksi (Korsak) bersangkutan untuk aktivasi.</li>
                          <li>Setelah diaktivasi saksi dapat login menggunakan username/hp dan password yang telah dibuat sebelumya</li>
                          <li>Saksi menginputkan data C1 ke form realcount yang tersedia pada aplikasi setelah perhitungan selesai.</li>
                          <li>Selamat menggunakan aplikasi</li>
                          </ul>        
                          <br/>
                          <div style="text-align: center;">
                            <u><b>RINCIAN TUGAS SAKSI</b></u>
                          </div>
                          <div style="text-align: justify;">
                          <b>SEBELUM PEMUNGUTAN SUARA</b>
                          </div>
                            <ul style="text-align: justify;">
                            <li>Saksi menyiapkan kelengkapan seperti KTP dan Kartu Pemilih untuk dibawa pada saat bertugas.</li>
                            <li>Saksi harus memegang surat mandat atau surat tugas dari Peserta Pemilu yang menugasinya (tanpa itu dia akan jadi saksi ilegal).</li>
                            <li>Menyiapkan Formulir yang disiapkan oleh Tim Kampanye dari Peserta Pemilu.</li>
                            <li>Bila ada, hendaknya membawa buku / pedoman saksi.</li>
                            <li>Membawa Kelengkapan tulis menulis</li>
                            <li>Saksi wajib hadir sebelum dimulainya Pemungutan Suara, sebaiknya sebelum pukul 07.00</li>
                            <li>Saksi harus menyerahkan Surat / Mandat (SK) sebagai Saksi dari Peserta Pemilu kepada KPPS dan meminta <b>bukti tanda terima surat </b>minimal paling lambat 1 hari sebelum Pemilu. Simpan dan jangan sampai hilang.</li>
                            </ul>
                            <div style="text-align: justify;">
                            <b>PADA SAAT MULAI PROSES PEMUNGUTAN SUARA</b></div>
                            <ul style="text-align: justify;">
                            <li>Saksi harus memastikan bahwa kotak suara dalam keadaan tersegel dan kosong.</li>
                            <li>Memastikan kelengkapan dan kondisi TPS yang aman dari gangguan dan kecurangan.</li>
                            <li>Memastikan sampul surat suara dalam keadaan tersegel dan JUMLAH surat suara sesuai dengan jumlah PEMILIH dalam DPT ditambah dengan 2,5 % surat suara CADANGAN yang semuanya tersegel aman.</li>
                            <li>Memastikan bahwa kotak suara benar-benar kosong dan dikunci kembali setelah di cek secara bersama-sama.</li>
                            <li>Pada saat MULAI PEMUNGUTAN Suara, pastikan bahwa pemilih memberikan hak pilihnya sesuai urutan kehadiran.</li>
                            <li>Memastikan bahwa Pemilih dan KPPS tidak memberikan suara ganda atau lebih dari 1 kali.</li>
                            <li>Memastikan bahwa nama pemilih sesuai dengan daftar nama yang tercantum di DPT</li>
                            <li>Pastikan bahwa pemilih tidak memiliki tanda khusus bahwa dia telah memberikan suara (seperti bekas tinta di jarinya).</li>
                            <li>Pastikan bahwa setiap surat suara yang diterima pemilih tidak cacat dan ada tanda-tanda khusus.</li>
                            <li>Pastikan bahwa setiap surat suara yang diterima pemilih suda ditandatangani oleh ketua KPPS.</li>
                            <li>Apabila ada pemilih yang datang tidak membawa undangan pemilih atau tidak memiliki kartu pemilih maka pastikan dia membawa KTP asli dan KK Asli, mereka akan dilayani setelah jam 12.00</li>
                            <li>Pastikan bahwa tidak ada panitia pemilu atau unsur KPPS yang mencoba mempengaruhi pemilih untuk memilih parpol / calon tertentu.</li>
                            <li>Bagi Pemilih yang pindah pilih harus menyertakan form A5 dan waktu coblosnya siang hari. </li>
                            </ul>
                            <div style="text-align: justify;">
                            <b>PADA SAAT PERHITUNGAN SUARA</b></div>
                            <ul style="text-align: justify;">
                            <li>Memastikan Perhitungan suara dimulai setelah pemungutan suara berakhir. Waktu pemungutan suara adalah pukul 13.00 atau sesuatu peraturan baru dari KPU</li>
                            <li>Pastikan bahwa suara yang tidak terpakai telah diberi tanda silang besar oleh petugas KPPS</li>
                            <li>Pastikan bahwa petugas KPPS telah mencatat jumlah surat suara yang tidak digunakan, cacat, ada coretan dst.</li>
                            <li>Awasi setiap perhitungan suara dengan melihat langsung bentuk fisik kertas suara pemilih.</li>
                            <li>Menghitung dan mencatat jumlah surat suara yang sah dan tidak sah serta jumlah perolehan suara masing-masing peserta pemilu.</li>
                            <li>Mengawasi Pengisian formulir Berita Acara Pemungutan Suara dan Penghitungan Suara (BAPPS) oleh KPPS.</li>
                            <li>Sebaiknya lembaran perhitungan yang dipasang di dinding / Plano di foto.</li>
                            <li>SImpanlah hasil perhitungan di TPS (Form C1), pastikan SAMA dengan hasil rekapitulasi di tingkat Kelurahan, Kecamatan dan Kota. Sebab sering terjadi perubahan suara di form D1.</li>
                            <li>Selama menjalankan tugas SAKSI jangan sampai meninggalkan lokasi tugasnya. Sebaiknya saksi lebih amannya 2 orang per TPS, bisa gantian jaga.</li>
                            </ul>
                            <div style="text-align: justify;">
                            <b>SETELAH PEMUNGUTAN SUARA</b></div>
                            <ul style="text-align: justify;">
                            <li>Saksi harus mencatat bila ada pelanggaran terjadi dan dilaporkan kepada Pengawas Pemilu Lapangan dan kepada Petugas Parpol/ Tim Calon yang memberinya mandat menjadi Saksi.</li>
                            <li>Saksi harus mengawal proses penyimpanan kotak suara dari TPS ke PPS.</li>
                            <li>Saksi menandatangani BAPPS apabila pelaksanaan pemungutan suara berjalan lancar dan jurdil</li>
                            <li>Apabila tidak ada keberatan maka Saksi meminta pada petugas KPPS untuk menuliskan kata NIHIL pada formulir lembaran pernyataan keberatan saksi yang berarti proses pemungutan suara sudah benar.</li>
                            <li>Apabila terdapat kecurangan yang merugikan parpol / calon yang memberikan mandat maka Saksi berhak tidak menandatangani BAPPS serta meminta petugas KPPS mencatat dengan jelas isi keberatan Saksi pada lembar Pernyataan Keberatan Saksi.</li>
                            <li>Saksi TPS harus memperoleh salinan dokumen yang menjadi haknya dari KPPS berupa: 1) BAPPS (Formulir C-KWK). 2) Catatan Pelaksanaan Pemungutan dan Perhitungan Suara (C1-KWK). 3) Sertifikat Hasil Penghitungan Suara (Lampiran C1-KWK). 4) Lembar Pernyataan Keberatan Saksi (C3-KWK).</li>
                            <li>Saksi memastikan bahwa seluruh dokumen pemungutan suara dimasukkan ke dalam kota suara dan di segel.</li>
                            </ul>
                            <div style="text-align: justify;">
                            <b>HAL - HAL <strike>MODUS</strike> YANG HARUS DIWASPADAI OLEH SAKSI:</b></div>
                            <ul style="text-align: justify;">
                            <li>Masih terdapat alat peraga kampanye di sekitar TPS</li>
                            <li>Jumlah Pemilih yang tercantum dalam DPT di TPS lebih dari 600 orang.</li>
                            <li>Pemungutan suara tidak boleh dilakukan sebelum KPPS membuka acara pemungutan suara secara resmi.</li>
                            <li>Jangan sampai surat suara kurang dari jumlah pemilih TPS. Jumlah Surat suara harus sama ditambah dengan 2 persen surat suara cadangan.</li>
                            <li>Janga sampai Pemilih tertentu diberi surat suara lebih dari jumlah yang ditentukan (Untuk Pemilu Serentak jumlah kartu suara adalah 5 buah: PIPRES + DPRD + DPRD Provinsi + DPR RI + DPD.</li>
                            <li>Pada Pemilukada dan atau PILPRES yang masih terpisah seperti saat ini surat suara hanya 1 Lembar per Pemilih.</li>
                            <li>KPPS jangan sampai tidak memeriksa kelengkapan pemilih terutama pemilih yang tidak memiliki kartu tanda pemilih.</li>
                            <li>Jangan sampai surat suara yang sudah dicoblos, dicoblos lagi oleh panitia untuk sengaja merusak suara calon yang tidak diinginkannya.</li>
                            <li>Jangan sampai suara suara parpol / calon tertentu yang sah dibacakan sebagai suara sah bagi calon lainnya</li>
                            <li>Surat Suara sah parpol / calon yang didukung dibacakan sebagai&nbsp; surat suara tidak sah atau rusak.</li>
                            <li>Petugas menulis suara sah bukan pada kolom yang tepat.</li>
                            <li>Petugas tidak mencatat dengan benar surat suara yang tidak terpakai.</li>
                            <li>Waspadai perubahan jumlah suara di tingkat KELURAHAN/ DESA! </li>
                            </ul>
                            <div style="text-align: justify;">
                            <b>BILA ADA INDIKASI / KESALAHAN OLEH PETUGAS MAKA:</b></div>
                            <ul style="text-align: justify;">
                            <li>Saksi TPS harus segera meminta KPPS untuk melakukan pembetulan saat itu juga. Bila tidak dihiraukan maka saksi harus mencatatnya sebagai pelanggaran / kecurangan dalam formulir pelanggaran yang ada dalam buku pedoman saksi.</li>
                            <li>Setiap pelanggaran / kecurangan saksi wajib mencatatnya dengan detail.</li>
                            </ul>
                                                                              
                      </v-card-text>
                    </v-card>
                  </v-tab-item>                                
                </v-tabs-items>
              </v-tabs>                
            </v-card-text>
          </v-card>                            
        </v-flex>            
        <v-flex xs12 sm12 md4>              
          <v-card class="elevation-5" >
            <v-toolbar dense flat>
              <v-toolbar-title class="primary--text">
                Sign up form
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text class="px-3">                           
              <v-text-field
                name="token"
                append-icon="fa fa-500px fa-lg"
                label="PIC Referal Token"
                v-model="model.token"   
                v-validate="'required'"
                data-vv-name="token"     
                v-bind:error-messages="errors.collect('token')"  
                required
              ></v-text-field>
              <v-layout row wrap>
                <v-flex xs7 pb-0 pt-0>
                  <v-text-field 
                    append-icon="fa fa-user fa-lg" 
                    name="username" 
                    label="Username" 
                    type="text" 
                    v-model="model.username"
                    v-validate="'required'"
                    data-vv-name="username"     
                    v-bind:error-messages="errors.collect('username')"  
                    required
                    @keyup="setEmail()"
                  ></v-text-field>                  
                </v-flex>
                <v-flex xs5 pb-0 pt-0>
                  <v-text-field 
                    append-icon="fa fa-phone fa-lg" 
                    name="phone" label="Phone" 
                    type="text" v-model="model.phone"
                    v-validate="'required'"
                    data-vv-name="phone"     
                    v-bind:error-messages="errors.collect('phone')"  
                    required
                  ></v-text-field>                  
                </v-flex>
              </v-layout>
              <!--<v-text-field append-icon="fa fa-at fa-lg" name="email" label="email" type="text" v-model="model.email"></v-text-field>-->
              <v-text-field
                append-icon="fa fa-at fa-lg"            
                v-validate="'required|email'"
                v-model="model.email"
                :error-messages="errors.collect('email')"
                label="E-mail"
                data-vv-name="email"
                required
              ></v-text-field>  
              <v-text-field 
                 append-icon="fa fa-lock fa-lg" 
                 name="password" 
                 label="Password" 
                 id="password" 
                 v-model="model.password" 
                 @keyup.enter="login"                
                 :append-icon="show3 ? 'visibility' : 'visibility_off'"                    
                 :type="show3 ? 'text' : 'password'"
                 @click:append="show3 = !show3"   
                 v-validate="'required'"
                data-vv-name="password"     
                v-bind:error-messages="errors.collect('password')"  
                required
               ></v-text-field>                                          
              <v-img class="mb-3" :src="cropImg" style="width: 100%;" alt="Cropped Image" >
                <v-btn dark small round color="cyan" @click="dialog_ktp = true" class="ml-1">Upload Foto KTP</v-btn>
              </v-img>
              <v-textarea v-model="model.description" label="Message or description" placeholder="exp : Saya saksi di TPS 1 Sukamaju" append-icon="fa fa-envelope fa-lg" hide-details >                
              </v-textarea>
              <v-text-field name="captcha" @keyup.enter="register" label="Captcha" type="text" v-model="model.captcha" hide-details>
                <template slot="append">
                  <v-fade-transition leave-absolute>
                    <v-progress-circular
                      v-if="!captcha"
                      size="24"
                      width="2"
                      color="info"
                      indeterminate
                    ></v-progress-circular>
                    <img class="cursor" @click="setCaptcha()" v-else :src="captcha" alt="">
                  </v-fade-transition>
                </template>                      
              </v-text-field>
            </v-card-text>
            <v-card-actions class="px-3"> 
              <p class="caption mr-3">By clicking Register, you agree to our Terms, Data Policy and Cookie Policy.</p>
              <v-spacer></v-spacer>
              <v-btn block color="primary" @click="register" :loading="loading">Register</v-btn>
            </v-card-actions>
            <v-card-actions class="grey lighten-4 mt-2">  
              <v-btn flat color="orange" @click="$router.push({path:'/login'})">
                Already have account ?
              </v-btn>
            </v-card-actions>  
          </v-card>
        </v-flex>           
      </v-layout>
      <v-dialog v-model="dialog_ktp" max-width="500px">
        <v-card>
          <v-card-title class="title">
            Upload Foto KTP
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-2">            
            <input type="file" name="image" accept="image/*" ref="ktp" style="display:none; font-size: 1.2em; padding: 10px 0;" @change="setImage" />
            <v-btn icon small color="blue" dark fab @click="$refs.ktp.click()" :loading="fileLoading"><v-icon>collections</v-icon></v-btn>
            <v-btn icon small color="blue-grey" dark fab @click="rotate" v-if="imgSrc != ''"><v-icon>rotate_right</v-icon></v-btn>
            
            <div style="width: 100%; min-height:200px; border: 1px solid gray; display: inline-block;">
              <div :style="imgSrc != ''?'':'display:none'">
                <vue-cropper
                    ref='cropper'
                    :guides="true"
                    :view-mode="2"
                    drag-mode="crop"
                    :auto-crop-area="0.8"
                    :min-container-width="250"
                    :min-container-height="180"
                    :background="true"
                    :rotatable="true"
                    :src="imgSrc"
                    alt="Source Image"
                    :img-style="{ 'width': '400px', 'height': '250px' }">
                </vue-cropper>
              </div>  
            </div>                            
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" flat @click="dialog_ktp=false">Close</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="success" :loading="croploading" @click="cropImage();" v-if="imgSrc != ''">Crop</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>    
  </v-app>
</template>

<script>
import config from '@/config';  
import AppSnackbar from '../components/app/Snackbar';
import Device from '@/util/models/Device'; 
import User from '@/util/models/User'; 
import VueCropper from 'vue-cropperjs';


const assets = require.context('@/assets/');
export default {
  $_veeValidate: {
      validator: 'new'
  },  
  components: {
    AppSnackbar,
    VueCropper,
  },      
  data () {
    return {
      show3:false,
      color:config.color, 
      selectedTab: null,
      loading: false,
      captcha: null,
      model: {
        username:'',
        email: '',        
        phone: '',
        password: '',          
        token:'',
        description:'',
        captcha:''
      },
      snackbar : AppSnackbar,
      image : '',
      show: true,
      dialog_ktp : false,
      imgSrc: '',
      cropImg: '',
      croploading : false,
      fileLoading : false
    };
  },
  watch:{
    
  },
  computed: {
    computeImage(gambar) {
      return assets('./bg/accounting.jpg');
    },
  },
  mounted(){
    this.setCaptcha();    
  },
  methods: {    
    setEmail(){
        this.model.email = this.model.username + '@realcount.co.id';      
    },  
    
    setCaptcha(){
        this.captcha = null;
        User.captcha().then(res=>{            
            if(res.status === 200){
                this.model.captcha = null;
                this.captcha = res.data;
            }
        });
    },
    
    register() {
        this.$validator.validateAll();
        if( !this.errors.any() ) {
            this.loading = true;
            var FormData = require('form-data');
            let formData = new FormData();
          
            for(var key in this.model){
              formData.append(key, this.model[key]);
            }
            
            if(this.$refs.cropper.getCroppedCanvas()){            
              this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
                let file = new File([blob], "uploaded_file.jpg", { type: "image/jpeg", lastModified: Date.now() });
                const fr = new FileReader();                
                fr.readAsDataURL(file);
                fr.addEventListener('load', () => {
                  formData.append('content', file, file.name);
                  this.signup(formData);
                });                                    
              });
            } else {
              this.signup(formData);
            }
            
          //formData.append('content', files[0], files[0].name);
          //formData.append('reff_id', this.user_id);
          
            
            
        }
    },
    
    signup(formData){
      User.signup(formData).then(res=>{
        if(res.status === 200){        
            this.$swal({ 
              type: 'success', 
              title: 'Contact your PIC for activation!',
              text:'Your account has been registered but your must contact your PIC for activation, after that you can just log in, thank you.',
              showConfirmButton: true, /*timer: 1000*/}).then((value) => {
                this.$router.push({path:'/login'});
              });
              //setTimeout(() => {}, 1000);
        } else {
            var title = res.status ? '#'+res.status + ' Oops...' : 'Oops...';
            var text  = res.statusText ? res.statusText: 'Something happened in setting up the request that triggered an Error.';                     
            if(res.data){ if(res.data.message){ text += ' ' + res.data.message; } else {this.validate(res.data);}}                
            this.$swal({type: 'error', title: title, text: text}); 
        }
        setTimeout(() => {this.loading = false;}, 1000);
      });
    },
    
    validate(data){
      this.setCaptcha();
      data.forEach( (item) => {
        if(item.field == 'parent_id'){
          this.$validator.errors.add({field : 'token',msg : 'Referal Code not validate !'});
        } else {
          this.$validator.errors.add({field : item.field,msg : item.message});
        }
      });
    },  
    
    openSetting(){
        window.getApp.$emit('APP_OPEN_DIALOG_SETTING');        
    },               
    
    setImage(e) {
      
      const file = e.target.files[0];
      console.log(e.target.files[0]);
      if (!file.type.includes('image/')) {
        alert('Please select an image file');
        return;
      }
      if (typeof FileReader === 'function') {
        const reader = new FileReader();
        this.fileLoading = true;
        reader.onload = (event) => {
          this.imgSrc = event.target.result;
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result);
          this.fileLoading = false;
        };
        reader.readAsDataURL(file);
      } else {
        alert('Sorry, FileReader API not supported');
      }
      
    },
      
    cropImage() {
      
      // get image data for post processing, e.g. upload or setting image src
      this.croploading = true;
      setTimeout(()=>{
          this.cropImg     = this.$refs.cropper.getCroppedCanvas().toDataURL();
          this.dialog_ktp  = false;
          this.croploading = false;
      }, 300);
          
      //this.croploading = false;
      /*this.$refs.cropper.getCroppedCanvas().toBlob((blob, tes) => {
        console.log(blob, tes);
        //this.cropImg = 
      });*/
      //this.cropImg = this.$refs.cropper.getImageData();
    },
    rotate() {
      // guess what this does :)
      this.$refs.cropper.rotate(90);
    },
  }

};
</script>
<style scoped lang="css">
  .device-register {
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
  }
</style>
